import actionTypes from '../actionTypes';

export const removeDealBlockChanges = (id) => ({
  type: actionTypes.DEAL_BLOCK_REMOVE_CHANGES,
  payload: { id },
});

export const setDealBlockChanges = (payload) => ({
  type: actionTypes.DEAL_BLOCK_SET_CHANGES,
  payload,
});

export const resetDealBlockChanges = () => ({
  type: actionTypes.DEAL_BLOCK_RESET_CHANGES,
});



// WEBPACK FOOTER //
// src/redux/actions/dealBlocks.js